import React, { useState, useEffect, useContext } from 'react'

import cartasMujeres from '../../../assets/images/cartasMujeres.png'

import Button from '../../atoms/button/button'

import userSessionStorage from '../../../utils/userSessionStorage'
import gameServices from '../../../services/game-service'
import { siteUrl } from '../../../shared/utils/siteUrl'

import { Context } from '../../../context/app-context'

import {
  dateEndGame,
  gameId,
  topNumber,
} from '../../../constants/activity-constants'

import './topSection.scss'
import { navigate } from 'gatsby'

const TopSection = props => {
  const { mobile } = props

  const session = new userSessionStorage()
  const { dispatch } = useContext(Context)

  const [userData, setUserData] = useState({})
  const [topWinners, setTopWinners] = useState([])

  useEffect(() => {
    getTop()
  }, [])

  const getTop = () => {
    let tokenId = session.getToken()?.idToken
    const config = {
      headers: tokenId
        ? {
            Authorization: tokenId,
          }
        : undefined,
    }
    gameServices.getTopPagination(gameId, topNumber, 0, config).then(res => {
      if (res.status === 200) {
        setUserData(res.data)
        setTopWinners(res.data.topGame)
        // console.log(res)
      }
    })
  }

  const formatNumber = number => {
    if (number) return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return
  }

  const modalLogin = () => {
    dispatch({
      type: 'set',
      payload: {
        modalActive: {
          type: 'login',
          handleClose: () => {
            navigate('/')
          },
          props: {
            colorBlur: 'pink-login',
            // handleSuccess: () => {
            //   window.location.reload()
            // },
            close: () => {
              dispatch({
                type: 'set',
                payload: {
                  modalActive: null,
                },
              })
            },
          },
        },
      },
    })
  }

  return (
    <div className="f-topSection-container">
      <div id="top-jugadoras" className="f-topSection-container__ancla" />
      <div className="f-topSection-container__wrapper">
        <div className="f-topSection-container__wrapper__topLeft">
          {session.getUserInfo() ? (
            <>
              <h2>
                TOP <br /> JUGADORAS
              </h2>
              <h3>¡HOLA {session.getUserInfo().name.split(' ')[0]}!</h3>
              <div className="f-topSection-container__wrapper__topLeft__contentUser">
                <div className="f-topSection-container__wrapper__topLeft__contentUser__datos">
                  <span>
                    TUS PUNTOS <br />
                    <b>{userData.point ? formatNumber(userData.point) : 0}</b>
                  </span>
                </div>
                <div className="f-topSection-container__wrapper__topLeft__contentUser__datos">
                  <span>
                    TU PUESTO <br /> <b>{userData.position}</b>
                  </span>
                </div>
              </div>
              <p>
                Si no estás en nuestro <span>top {topNumber}</span> ¡sigue
                jugando y no te rindas! tienes hasta el {dateEndGame} para
                alcanzar los mejores puntajes. <br /> <br />
                <span>¡Participa y diviértete!</span>
              </p>
              <Button
                text="JUGAR"
                size="registrate"
                onClick={() => {
                  navigate('/juega')
                }}
              />
            </>
          ) : (
            <>
              <h2 className="noLogueadoTitulo">
                TOP <br /> JUGADORAS
              </h2>
              {!mobile && (
                <img src={cartasMujeres} alt="cartas de mujeres famosas" />
              )}
              <p>
                <span onClick={() => modalLogin()} className="subrayado">
                  Inicia sesión
                </span>{' '}
                para conocer tu puntaje y tu posición dentro del top de
                jugadoras. <br /> <br /> Si aún no formas parte de
                NosotrasOnline
              </p>
              <Button
                text="REGÍSTRATE AQUÍ"
                tercery
                size="registrate"
                onClick={() => {
                  window.open(
                    siteUrl + '/registro/fecha-de-nacimiento/',
                    '_blank'
                  )
                }}
              />
            </>
          )}
        </div>
        <div className="f-topSection-container__wrapper__topRight">
          <div className="f-topSection-container__wrapper__topRight__contentTop">
            <h3>Las mejores jugadoras están aquí:</h3>
            <ul>
              {topWinners.map((item, index) => {
                return (
                  <li key={'top' + index}>
                    <span>
                      <div className="rombo" /> <b>{index + 1}</b> {item.name}
                    </span>
                    <br />
                    <span className="correo">{item.email}</span>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
      <a
        onClick={() => {
          dispatch({
            type: 'set',
            payload: {
              modalActive: {
                type: 'terms',
                props: {
                  close: () => {
                    dispatch({
                      type: 'set',
                      payload: {
                        modalActive: null,
                      },
                    })
                  },
                },
              },
            },
          })
        }}
      >
        Términos y condiciones de la actividad
      </a>
    </div>
  )
}

export default TopSection
